/**
 * O `signup()` foi recusado porque o CPF já tem conta?
 *
 * Com Import Users, a Auth0 confere o store e o Get User da Custom Database
 * antes do Create e recusa o cadastro — a tela recebe isso como erro de
 * transação. O código exato não está documentado para o ACUL, então aceitamos
 * os códigos conhecidos e o texto padrão (inglês ou pt-BR).
 */

type TransactionError = { code?: string; message?: string }

const CODES = new Set(['user-exists', 'username-exists', 'user_exists'])
const MESSAGE = /already exists|já existe/i

export function isUserExistsError(errors: TransactionError[] | undefined): boolean {
  return (errors ?? []).some(
    (error) =>
      CODES.has(String(error.code ?? '')) || MESSAGE.test(String(error.message ?? '')),
  )
}
